import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { ThemeProvider } from "@/context/ThemeContext";
import { Toaster } from "@/components/ui/sonner";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import HomePage from "@/pages/HomePage";
import CategoryPage from "@/pages/CategoryPage";
import DestinationDetail from "@/pages/DestinationDetail";
import LoginPage from "@/pages/LoginPage";
import Dashboard from "@/pages/Dashboard";
import FavoritesPage from "@/pages/FavoritesPage";
import AdminPanel from "@/pages/AdminPanel";
import GlimpsesPage from "@/pages/GlimpsesPage";
import AdminGlimpsesPage from "@/pages/AdminGlimpsesPage";
import NotFoundPage from "@/pages/NotFoundPage";
import { PaymentSuccess, PaymentCancel } from "@/pages/PaymentPages";
import WhatsAppButton from "@/components/WhatsAppButton";
import { useEffect } from "react";

function AppShell() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.history.scrollRestoration = "manual";
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-1">
        <Routes>
          <Route path="/" element={<HomePage />} />
          {/* Retire the obsolete, empty category URL rather than serving a thin page. */}
          <Route path="/category/travel-guide" element={<Navigate to="/" replace />} />
          <Route path="/category/:slug" element={<CategoryPage />} />
          <Route path="/destination/:slug" element={<DestinationDetail />} />
          <Route path="/glimpses" element={<GlimpsesPage />} />
          <Route path="/login" element={<LoginPage mode="login" />} />
          <Route path="/signup" element={<LoginPage mode="signup" />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/favorites" element={<FavoritesPage />} />
          <Route path="/admin" element={<AdminPanel />} />
          <Route path="/admin/glimpses" element={<AdminGlimpsesPage />} />
          <Route path="/payment/success" element={<PaymentSuccess />} />
          <Route path="/payment/cancel" element={<PaymentCancel />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </main>
      <Footer />
      <WhatsAppButton />
    </div>
  );
}

export default function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <BrowserRouter>
          <AppShell />
          <Toaster richColors position="top-center" />
        </BrowserRouter>
      </AuthProvider>
    </ThemeProvider>
  );
}
